import { render, staticRenderFns } from "./StackedModal.vue?vue&type=template&id=0da2f2bc&scoped=true"
import script from "./StackedModal.vue?vue&type=script&lang=js"
export * from "./StackedModal.vue?vue&type=script&lang=js"
import style0 from "./StackedModal.vue?vue&type=style&index=0&id=0da2f2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da2f2bc",
  null
  
)

export default component.exports